import { hiddenListCaps, listCapSentence, type ListCap } from '@/lib/desk/list-caps';

export function ListCapBanner({ caps }: { caps: ListCap[] }) {
  const hidden = hiddenListCaps(caps);
  if (hidden.length === 0) return null;
  return (
    <div className="mb-4 rounded-2xl border border-warning/30 bg-warning/10 px-4 py-3 text-xs font-semibold text-warning">
      {hidden.map((cap) => (
        <p key={cap.label}>{listCapSentence(cap)}</p>
      ))}
    </div>
  );
}
